export const fleetSize = [
  { text: 'Micro (1-5)', value: 'some-guid-1' },
  { text: 'Small (6-50)', value: 'some-guid-2' },
  { text: 'Medium (51-150)', value: 'some-guid-3' },
  { text: 'Large (151-500)', value: 'some-guid-4' },
  { text: 'Extra Large (501+)', value: 'some-guid-5' },
];

export const solutions = [
  { checked: false, id: 'some-guid-1', text: 'Software' },
  { checked: false, id: 'some-guid-2', text: 'Charging' },
  { checked: false, id: 'some-guid-3', text: 'Service' },
  { checked: false, id: 'some-guid-4', text: 'Vehicles' },
];
